import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "SiteKeywordsListViewContainer"
};
const _hoisted_2 = {
  class: "leftCenter"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "colFlex bothCenter"
};
const _hoisted_5 = {
  key: 0,
  class: "bothCenter colFlex"
};
const _hoisted_6 = {
  key: 1,
  class: "bothCenter colFlex"
};
const _hoisted_7 = {
  class: "leftCenter"
};
const _hoisted_8 = {
  key: 0,
  src: "https://cdn.waityou.online/736652c6-a95c-f436-1dc5-4b44507142ca.png",
  class: "sqr16 mr6"
};
const _hoisted_9 = {
  key: 1,
  src: "https://cdn.waityou.online/53543ff1-c94a-8357-9be6-3cbdcf9315b9.png",
  class: "sqr16 mr6"
};
const _hoisted_10 = {
  key: 2,
  src: "https://cdn.waityou.online/f20f781c-4f06-dd03-eb6d-645acc31629d.svg",
  class: "sqr16 mr6"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1,
  class: "light"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_EmdEnumValueListView, {
          type: "SITE_KEYWORDS",
          onOnRowSelectChange: $options.onRowSelectChange,
          onShowRefCnt: $options.showRefCnt,
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'SITE_KEYWORDS',
            refId: site.value,
            sort: true,
            extra: true
          },
          title: "站点关键词配置",
          "add-btn": `添加${site.label}站点关键词`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            disabled: $data.selected.length < 1,
            type: "primary",
            onClick: $options.openReplaceForm
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("替换关键词")])),
            _: 1
          }, 8, ["disabled", "onClick"])]),
          _: 2
        }, 1032, ["onOnRowSelectChange", "onShowRefCnt", "init-query", "add-btn"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_ButtonDialog, {
    "btn-name": "",
    style: 1,
    "bind-id": $data.selected[0],
    ref: "replaceForm",
    "init-data": {
      fromIds: $data.selected
    },
    "btn-id": 14
  }, null, 8, ["bind-id", "init-data"]), _createVNode(_component_DialogCustomView, {
    title: "引用关键词的文章列表",
    width: "1000px",
    "visible-control": $data.viewRefArticles,
    onClose: _cache[1] || (_cache[1] = $event => $data.viewRefArticles = false)
  }, {
    default: _withCtx(() => [$data.viewRefArticles ? (_openBlock(), _createBlock(_component_BatterTableDataView, {
      key: 0,
      "table-id": 13,
      "init-query": {
        keyword: $data.kwdId
      }
    }, {
      title: _withCtx(data => [_createElementVNode("div", _hoisted_2, [data.data.schoolId != null ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "item",
        effect: "dark",
        content: data.data.schoolName,
        placement: "top"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
          src: "https://cdn.waityou.online/439a2635-e911-3559-3581-b16eb0f557e0.svg",
          class: "sqr16 mr12"
        }, null, -1)])),
        _: 2
      }, 1032, ["content"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data.rowData), 1), _createElementVNode("img", {
        src: "https://cdn.waityou.online/2365e64e-2a44-1825-5e8e-bc6f14e27426.svg",
        onClick: $event => $options.previewHtml(data.data),
        class: "ml12 sqr20"
      }, null, 8, _hoisted_3)])]),
      readCnt: _withCtx(data => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(data.rowData), 1)])]),
      copySize: _withCtx(data => [data.data.copySourceId == null ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(data.rowData), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [_createElementVNode("span", null, "-", -1)])))]),
      nav: _withCtx(data => [_createElementVNode("div", _hoisted_7, [data.data.hotSearchTag == 'HOT' ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NEW' ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NONE' ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data?.data?.nav?.label) + " / " + _toDisplayString(data?.data?.subNav?.label), 1)])]),
      subNav: _withCtx(data => [data?.data?.subNav ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(data?.data?.subNav?.label), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_12, "无"))]),
      _: 1
    }, 8, ["init-query"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}